import { useCallback, useMemo } from 'react';
import {
  updateMetroSearchMarketPromotionsContext,
  useUiValue,
} from 'stores/uiContext';

const normalizeMarket = (value) =>
  value ? value.toString().trim().toLowerCase() : '';

const mapPromotion = (promotion) => {
  if (!promotion) return null;
  const logo =
    promotion.searchLogo && promotion.searchLogo.src
      ? promotion.searchLogo
      : promotion.logo;

  return {
    logo: logo && logo.src,
    logoAlt: logo && logo.alt,
    title: promotion.offerText,
    rateLabel: promotion.offerSubtext,
    description: promotion.text,
    cta: {
      text: promotion.ctaText || (promotion.ctaLink && promotion.ctaLink.text),
      href: promotion.ctaLink && promotion.ctaLink.href,
      target: promotion.ctaLink && promotion.ctaLink.target,
    },
  };
};

const useMetroSearchMarketPromotionCard = () => {
  const [{ metroSearchSelectedMetro, metroSearchMarketPromotions }, dispatch] =
    useUiValue();

  const updateMetroSearchMarketPromotions = useCallback(
    (promotions) => {
      dispatch(updateMetroSearchMarketPromotionsContext(promotions || []));
    },
    [dispatch],
  );

  const metroSearchMarketPromotionCard = useMemo(() => {
    if (
      !Array.isArray(metroSearchSelectedMetro) ||
      metroSearchSelectedMetro.length !== 1 ||
      !Array.isArray(metroSearchMarketPromotions)
    ) {
      return null;
    }
    const selectedMetro = normalizeMarket(metroSearchSelectedMetro[0].name);
    if (!selectedMetro) return null;

    const selectedPromotion = metroSearchMarketPromotions.find((promotion) => {
      if (!promotion) return false;

      return (
        selectedMetro === normalizeMarket(promotion.marketDisplayName) ||
        selectedMetro === normalizeMarket(promotion.marketName)
      );
    });

    return mapPromotion(selectedPromotion);
  }, [metroSearchSelectedMetro, metroSearchMarketPromotions]);

  return {
    metroSearchMarketPromotionCard,
    updateMetroSearchMarketPromotions,
  };
};

export default useMetroSearchMarketPromotionCard;
